import { useRouter } from 'next/router';
import React from 'react';
import { connect } from 'react-redux';

import withMembershipAccessWrap, {
  mapStateToProps,
} from '@/src/shared/components/MembershipPageWrap';
import { ADVOCACY_ACCESS } from '@/src/shared/constants';

function RedirectPage() {
  const router = useRouter();

  if (typeof window !== 'undefined') {
    router.push('/policy/committees/');
  }
  return null;
}

export default connect(mapStateToProps)(
  withMembershipAccessWrap(RedirectPage, ADVOCACY_ACCESS.POLICY_COMMITTEES)
);
